import React from 'react';

interface FormContainerProps {
  /**
   * Form content to display
   */
  children: React.ReactNode;
  /**
   * Maximum width of the form container
   * @default 500
   */
  maxWidth?: number;
}

/**
 * Molecule: Simple wrapper for form content
 * Provides consistent padding and max-width for readability
 * Clean, flat design with no card styling
 */
export const FormContainer: React.FC<FormContainerProps> = ({
  children,
  maxWidth = 500,
}) => {
  return (
    <div
      className="w-full px-6 py-8 sm:px-8"
      style={{ maxWidth: `${maxWidth}px` }}
    >
      {children}
    </div>
  );
};
